const createDefaultEntity = keys => {
  const entity = {};
  keys.forEach(key => {
    entity[key] = undefined; // eslint-disable-line no-undefined
  });
  return entity;
};

const entityFieldsProcessor = fields => sheetAsJson =>
  sheetAsJson.map(row => ({ ...createDefaultEntity(fields), ...row }));

export default entityFieldsProcessor;
